import Chip, { type ChipProps } from '@mui/material/Chip'
import { type SxProps } from '@mui/system'
import i18n from 'i18next'
import { type ReactElement } from 'react'
import { QuoteStatus } from 'screens/QuoteDetails/QuoteDetails.types'

export interface QuoteStatusChipProps {
  status: QuoteStatus
  sx?: SxProps
}

export const getComponentColor = (status: QuoteStatus): ChipProps['color'] => {
  switch (status) {
    case QuoteStatus.OPEN:
      return 'secondary'
    case QuoteStatus.SUBMITTED:
      return 'success'
    case QuoteStatus.REJECTED:
      return 'error'
    case QuoteStatus.CLOSED:
    default:
      return 'default'
  }
}

const QuoteStatusChip = ({ status, sx }: QuoteStatusChipProps): ReactElement => (
  <Chip label={i18n.t(`screens.cs.quotes.statuses.${status}`)} size="small" color={getComponentColor(status)} sx={sx} />
)

export default QuoteStatusChip
